const initialState = {
    isLoading: false,
    settlement: [],
    franchiseid:""
  };
  export default initialState;